// extracted by mini-css-extract-plugin
export var mySwiper = "section-module--mySwiper--olWq-";
export var swiperSlide = "section-module--swiperSlide--L9GMC";